import { LookupListItem } from '../../api/user/model';
import { GET_SCHOOLS_BY_TYPE_URL } from '../../constants/apiUrls';
import { GET_SCHOOLS_BY_TYPE_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

export const useGetSchoolsByType = (enabled: boolean, type: string) => {
  const getSchoolsByType = async () => {
    const res = await axiosClient.get<LookupListItem[]>(GET_SCHOOLS_BY_TYPE_URL(type));

    return res.data;
  };

  return useCustomQuery(
    GET_SCHOOLS_BY_TYPE_QUERY_KEY,
    getSchoolsByType,
    {
      enabled,
      staleTime: Infinity,
    },
    false
  );
};
